import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const routeMap: Record<string, string> = {
  '/': '首页',
  '/about': '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  if (pathSegments.length > 0) {
    if (pathSegments[0] === 'category') {
      items.push({ label: '分类', path: '/category/all' });
      if (pathSegments[1]) {
        const catName = routeMap[`/category/${pathSegments[1]}`] || pathSegments[1];
        items.push({ label: catName });
      }
    } else if (pathSegments[0] === 'article') {
      items.push({ label: '漫画详情' });
    } else {
      const label = routeMap[`/${pathSegments[0]}`] || pathSegments[0];
      items.push({ label, path: `/${pathSegments[0]}` });
    }
  }

  if (items.length <= 1) return null;

  return (
    <nav aria-label="breadcrumb" className="max-w-7xl mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center gap-2 text-xs text-foreground-500">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && (
              <span className="text-foreground-400">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            )}
            {item.path && index < items.length - 1 ? (
              <Link
                to={item.path}
                className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}